import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";

import ContactUsComponent from "../../components/misc/contact-us/ContactUs";
import { getContactUsPageLayout } from "components/service-pages/constants/company-pages-methods";

export default function ContactUsWeb() {
    return <ContactUsComponent />;
}

ContactUsWeb.getLayout = getContactUsPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("contactus")))
        }
    };
}
